"use client";

import { useTina, tinaField, coloredText } from "@/lib/utils";

import Section from "@/components/Section";
import CallToAction from "@/components/CallToAction";

import FAQs from "@/components/FAQs";

export default function FaqsPage(props) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  const { header } = data.faqsPage;
  return (
    <div>
      <Header header={header} />
      <FAQs
        faqs={data.faqsPage.faqs}
        tinaFieldData={data.faqsPage.faqs}
        wrapperClassName="bg-gradient-to-b from-background-blackish to-background-purplish"
      />
      <CallToAction callToAction={data.faqsPage.callToAction} />
    </div>
  );
}

const Header = ({ header }) => {
  const title = coloredText(header?.title);
  return (
    <Section
      as="header"
      wrapperClassName="!pb-0"
      className="flex flex-col gap-4 items-center justify-center text-center"
    >
      <h1
        data-tina-field={tinaField(header, "title")}
        className="text-balance"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p
        data-tina-field={tinaField(header, "subtitle")}
        className="max-w-[700px] p-xl text-foreground-500"
      >
        {header?.subtitle}
      </p>
    </Section>
  );
};
